import FractionalBrownianMotion from "./FractionalBrownianMotion";

export default class IndexGenerator {
    /**
     * 
     * @param {number} worldSeed 
     */
    constructor(worldSeed) {

        /**
         * The min value of the fbm is -2.27..., so we want to shift by that amount to get a positive result.
         * @constant
         * @type {number}
         */
        this.shiftValue = 2.2734306378540854; // <-- this is derived from the 'trueMinValue' below.

        /**
         * This is the FBM we'll use for 
         * @constant
         * @type {FractionalBrownianMotion}
         */
        this.indexFbm = new FractionalBrownianMotion(worldSeed, 1, 2.1, 0.7, 5, 0.0005);

        ////////////////////////////////////
        // Commented out code to derive the 
        // index lookup object.  
        ////////////////////////////////////

        // this.histogram = {};
        // this.trueMinValue = 100000000;
        // this.trueMaxValue = -1000000;
        // this.shiftedMinValue = 100000000;
        // this.shiftedMaxValue = -1000000;
        // this.workingIndexLookup = {};
        // this.deriveLookupTable();

        // This is generated by deriveLookupTable() (commented out above)
        // If we change the fbm configurations, we'll need to regenerate the lookup.
        this.indexLookup = {};
        this.indexLookup["0.00"] = 0;
        this.indexLookup["0.01"] = 0;
        this.indexLookup["0.02"] = 0;
        this.indexLookup["0.03"] = 0;
        this.indexLookup["0.04"] = 0;
        this.indexLookup["0.05"] = 0;
        this.indexLookup["0.06"] = 0;
        this.indexLookup["0.07"] = 0;
        this.indexLookup["0.08"] = 0;
        this.indexLookup["0.09"] = 0;
        this.indexLookup["0.10"] = 0;
        this.indexLookup["0.11"] = 0;
        this.indexLookup["0.12"] = 0;
        this.indexLookup["0.13"] = 0;
        this.indexLookup["0.14"] = 0;
        this.indexLookup["0.15"] = 0;
        this.indexLookup["0.16"] = 0;
        this.indexLookup["0.17"] = 0;
        this.indexLookup["0.18"] = 0;
        this.indexLookup["0.19"] = 0;
        this.indexLookup["0.20"] = 0;
        this.indexLookup["0.21"] = 0;
        this.indexLookup["0.22"] = 0;
        this.indexLookup["0.23"] = 0;
        this.indexLookup["0.24"] = 0;
        this.indexLookup["0.25"] = 0;
        this.indexLookup["0.26"] = 0;
        this.indexLookup["0.27"] = 0;
        this.indexLookup["0.28"] = 0;
        this.indexLookup["0.29"] = 0;
        this.indexLookup["0.30"] = 0;
        this.indexLookup["0.31"] = 0;
        this.indexLookup["0.32"] = 0;
        this.indexLookup["0.33"] = 0;
        this.indexLookup["0.34"] = 0;
        this.indexLookup["0.35"] = 0;
        this.indexLookup["0.36"] = 0;
        this.indexLookup["0.37"] = 0;
        this.indexLookup["0.38"] = 0;
        this.indexLookup["0.39"] = 0;
        this.indexLookup["0.40"] = 0;
        this.indexLookup["0.41"] = 0;
        this.indexLookup["0.42"] = 0;
        this.indexLookup["0.43"] = 0;
        this.indexLookup["0.44"] = 0;
        this.indexLookup["0.45"] = 0;
        this.indexLookup["0.46"] = 0;
        this.indexLookup["0.47"] = 0;
        this.indexLookup["0.48"] = 0;
        this.indexLookup["0.49"] = 0;
        this.indexLookup["0.50"] = 0;
        this.indexLookup["0.51"] = 0;
        this.indexLookup["0.52"] = 0;
        this.indexLookup["0.53"] = 0;
        this.indexLookup["0.54"] = 0;
        this.indexLookup["0.55"] = 0;
        this.indexLookup["0.56"] = 0;
        this.indexLookup["0.57"] = 0;
        this.indexLookup["0.58"] = 0;
        this.indexLookup["0.59"] = 0;
        this.indexLookup["0.60"] = 0;
        this.indexLookup["0.61"] = 0;
        this.indexLookup["0.62"] = 0;
        this.indexLookup["0.63"] = 0;
        this.indexLookup["0.64"] = 0;
        this.indexLookup["0.65"] = 0;
        this.indexLookup["0.66"] = 0;
        this.indexLookup["0.67"] = 0;
        this.indexLookup["0.68"] = 0;
        this.indexLookup["0.69"] = 0;
        this.indexLookup["0.70"] = 0;
        this.indexLookup["0.71"] = 0;
        this.indexLookup["0.72"] = 0;
        this.indexLookup["0.73"] = 0;
        this.indexLookup["0.74"] = 0;
        this.indexLookup["0.75"] = 0;
        this.indexLookup["0.76"] = 0;
        this.indexLookup["0.77"] = 0;
        this.indexLookup["0.78"] = 0;
        this.indexLookup["0.79"] = 0;
        this.indexLookup["0.80"] = 0;
        this.indexLookup["0.81"] = 0;
        this.indexLookup["0.82"] = 0;
        this.indexLookup["0.83"] = 0;
        this.indexLookup["0.84"] = 0;
        this.indexLookup["0.85"] = 0;
        this.indexLookup["0.86"] = 0;
        this.indexLookup["0.87"] = 0;
        this.indexLookup["0.88"] = 0;
        this.indexLookup["0.89"] = 0;
        this.indexLookup["0.90"] = 0;
        this.indexLookup["0.91"] = 0;
        this.indexLookup["0.92"] = 0.01;
        this.indexLookup["0.93"] = 0.01;
        this.indexLookup["0.94"] = 0.01;
        this.indexLookup["0.95"] = 0.01;
        this.indexLookup["0.96"] = 0.01;
        this.indexLookup["0.97"] = 0.01;
        this.indexLookup["0.98"] = 0.01;
        this.indexLookup["0.99"] = 0.01;
        this.indexLookup["1.00"] = 0.01;
        this.indexLookup["1.01"] = 0.01;
        this.indexLookup["1.02"] = 0.01;
        this.indexLookup["1.03"] = 0.01;
        this.indexLookup["1.04"] = 0.01;
        this.indexLookup["1.05"] = 0.01;
        this.indexLookup["1.06"] = 0.02;
        this.indexLookup["1.07"] = 0.02;
        this.indexLookup["1.08"] = 0.02;
        this.indexLookup["1.09"] = 0.02;
        this.indexLookup["1.10"] = 0.02;
        this.indexLookup["1.11"] = 0.02;
        this.indexLookup["1.12"] = 0.02;
        this.indexLookup["1.13"] = 0.02;
        this.indexLookup["1.14"] = 0.02;
        this.indexLookup["1.15"] = 0.03;
        this.indexLookup["1.16"] = 0.03;
        this.indexLookup["1.17"] = 0.03;
        this.indexLookup["1.18"] = 0.03;
        this.indexLookup["1.19"] = 0.03;
        this.indexLookup["1.20"] = 0.03;
        this.indexLookup["1.21"] = 0.04;
        this.indexLookup["1.22"] = 0.04;
        this.indexLookup["1.23"] = 0.04;
        this.indexLookup["1.24"] = 0.04;
        this.indexLookup["1.25"] = 0.04;
        this.indexLookup["1.26"] = 0.04;
        this.indexLookup["1.27"] = 0.05;
        this.indexLookup["1.28"] = 0.05;
        this.indexLookup["1.29"] = 0.05;
        this.indexLookup["1.30"] = 0.05;
        this.indexLookup["1.31"] = 0.05;
        this.indexLookup["1.32"] = 0.06;
        this.indexLookup["1.33"] = 0.06;
        this.indexLookup["1.34"] = 0.06;
        this.indexLookup["1.35"] = 0.06;
        this.indexLookup["1.36"] = 0.07;
        this.indexLookup["1.37"] = 0.07;
        this.indexLookup["1.38"] = 0.07;
        this.indexLookup["1.39"] = 0.07;
        this.indexLookup["1.40"] = 0.08;
        this.indexLookup["1.41"] = 0.08;
        this.indexLookup["1.42"] = 0.08;
        this.indexLookup["1.43"] = 0.08;
        this.indexLookup["1.44"] = 0.09;
        this.indexLookup["1.45"] = 0.09;
        this.indexLookup["1.46"] = 0.09;
        this.indexLookup["1.47"] = 0.1;
        this.indexLookup["1.48"] = 0.1;
        this.indexLookup["1.49"] = 0.1;
        this.indexLookup["1.50"] = 0.11;
        this.indexLookup["1.51"] = 0.11;
        this.indexLookup["1.52"] = 0.11;
        this.indexLookup["1.53"] = 0.12;
        this.indexLookup["1.54"] = 0.12;
        this.indexLookup["1.55"] = 0.12;
        this.indexLookup["1.56"] = 0.13;
        this.indexLookup["1.57"] = 0.13;
        this.indexLookup["1.58"] = 0.13;
        this.indexLookup["1.59"] = 0.14;
        this.indexLookup["1.60"] = 0.14;
        this.indexLookup["1.61"] = 0.15;
        this.indexLookup["1.62"] = 0.15;
        this.indexLookup["1.63"] = 0.15;
        this.indexLookup["1.64"] = 0.16;
        this.indexLookup["1.65"] = 0.16;
        this.indexLookup["1.66"] = 0.17;
        this.indexLookup["1.67"] = 0.17;
        this.indexLookup["1.68"] = 0.17;
        this.indexLookup["1.69"] = 0.18;
        this.indexLookup["1.70"] = 0.18;
        this.indexLookup["1.71"] = 0.19;
        this.indexLookup["1.72"] = 0.19;
        this.indexLookup["1.73"] = 0.2;
        this.indexLookup["1.74"] = 0.2;
        this.indexLookup["1.75"] = 0.21;
        this.indexLookup["1.76"] = 0.21;
        this.indexLookup["1.77"] = 0.21;
        this.indexLookup["1.78"] = 0.22;
        this.indexLookup["1.79"] = 0.22;
        this.indexLookup["1.80"] = 0.23;
        this.indexLookup["1.81"] = 0.23;
        this.indexLookup["1.82"] = 0.24;
        this.indexLookup["1.83"] = 0.24;
        this.indexLookup["1.84"] = 0.25;
        this.indexLookup["1.85"] = 0.25;
        this.indexLookup["1.86"] = 0.26;
        this.indexLookup["1.87"] = 0.26;
        this.indexLookup["1.88"] = 0.27;
        this.indexLookup["1.89"] = 0.27;
        this.indexLookup["1.90"] = 0.28;
        this.indexLookup["1.91"] = 0.29;
        this.indexLookup["1.92"] = 0.29;
        this.indexLookup["1.93"] = 0.3;
        this.indexLookup["1.94"] = 0.3;
        this.indexLookup["1.95"] = 0.31;
        this.indexLookup["1.96"] = 0.31;
        this.indexLookup["1.97"] = 0.32;
        this.indexLookup["1.98"] = 0.32;
        this.indexLookup["1.99"] = 0.33;
        this.indexLookup["2.00"] = 0.34;
        this.indexLookup["2.01"] = 0.34;
        this.indexLookup["2.02"] = 0.35;
        this.indexLookup["2.03"] = 0.35;
        this.indexLookup["2.04"] = 0.36;
        this.indexLookup["2.05"] = 0.36;
        this.indexLookup["2.06"] = 0.37;
        this.indexLookup["2.07"] = 0.38;
        this.indexLookup["2.08"] = 0.38;
        this.indexLookup["2.09"] = 0.39;
        this.indexLookup["2.10"] = 0.39;
        this.indexLookup["2.11"] = 0.4;
        this.indexLookup["2.12"] = 0.41;
        this.indexLookup["2.13"] = 0.41;
        this.indexLookup["2.14"] = 0.42;
        this.indexLookup["2.15"] = 0.42;
        this.indexLookup["2.16"] = 0.43;
        this.indexLookup["2.17"] = 0.44;
        this.indexLookup["2.18"] = 0.44;
        this.indexLookup["2.19"] = 0.45;
        this.indexLookup["2.20"] = 0.46;
        this.indexLookup["2.21"] = 0.46;
        this.indexLookup["2.22"] = 0.47;
        this.indexLookup["2.23"] = 0.47;
        this.indexLookup["2.24"] = 0.48;
        this.indexLookup["2.25"] = 0.49;
        this.indexLookup["2.26"] = 0.49;
        this.indexLookup["2.27"] = 0.5;
        this.indexLookup["2.28"] = 0.5;
        this.indexLookup["2.29"] = 0.51;
        this.indexLookup["2.30"] = 0.52;
        this.indexLookup["2.31"] = 0.52;
        this.indexLookup["2.32"] = 0.53;
        this.indexLookup["2.33"] = 0.53;
        this.indexLookup["2.34"] = 0.54;
        this.indexLookup["2.35"] = 0.55;
        this.indexLookup["2.36"] = 0.55;
        this.indexLookup["2.37"] = 0.56;
        this.indexLookup["2.38"] = 0.57;
        this.indexLookup["2.39"] = 0.57;
        this.indexLookup["2.40"] = 0.58;
        this.indexLookup["2.41"] = 0.58;
        this.indexLookup["2.42"] = 0.59;
        this.indexLookup["2.43"] = 0.6;
        this.indexLookup["2.44"] = 0.6;
        this.indexLookup["2.45"] = 0.61;
        this.indexLookup["2.46"] = 0.61;
        this.indexLookup["2.47"] = 0.62;
        this.indexLookup["2.48"] = 0.63;
        this.indexLookup["2.49"] = 0.63;
        this.indexLookup["2.50"] = 0.64;
        this.indexLookup["2.51"] = 0.64;
        this.indexLookup["2.52"] = 0.65;
        this.indexLookup["2.53"] = 0.65;
        this.indexLookup["2.54"] = 0.66;
        this.indexLookup["2.55"] = 0.67;
        this.indexLookup["2.56"] = 0.67;
        this.indexLookup["2.57"] = 0.68;
        this.indexLookup["2.58"] = 0.68;
        this.indexLookup["2.59"] = 0.69;
        this.indexLookup["2.60"] = 0.69;
        this.indexLookup["2.61"] = 0.7;
        this.indexLookup["2.62"] = 0.71;
        this.indexLookup["2.63"] = 0.71;
        this.indexLookup["2.64"] = 0.72;
        this.indexLookup["2.65"] = 0.72;
        this.indexLookup["2.66"] = 0.73;
        this.indexLookup["2.67"] = 0.73;
        this.indexLookup["2.68"] = 0.74;
        this.indexLookup["2.69"] = 0.74;
        this.indexLookup["2.70"] = 0.75;
        this.indexLookup["2.71"] = 0.75;
        this.indexLookup["2.72"] = 0.76;
        this.indexLookup["2.73"] = 0.76;
        this.indexLookup["2.74"] = 0.77;
        this.indexLookup["2.75"] = 0.77;
        this.indexLookup["2.76"] = 0.78;
        this.indexLookup["2.77"] = 0.78;
        this.indexLookup["2.78"] = 0.79;
        this.indexLookup["2.79"] = 0.79;
        this.indexLookup["2.80"] = 0.8;
        this.indexLookup["2.81"] = 0.8;
        this.indexLookup["2.82"] = 0.8;
        this.indexLookup["2.83"] = 0.81;
        this.indexLookup["2.84"] = 0.81;
        this.indexLookup["2.85"] = 0.82;
        this.indexLookup["2.86"] = 0.82;
        this.indexLookup["2.87"] = 0.83;
        this.indexLookup["2.88"] = 0.83;
        this.indexLookup["2.89"] = 0.83;
        this.indexLookup["2.90"] = 0.84;
        this.indexLookup["2.91"] = 0.84;
        this.indexLookup["2.92"] = 0.85;
        this.indexLookup["2.93"] = 0.85;
        this.indexLookup["2.94"] = 0.85;
        this.indexLookup["2.95"] = 0.86;
        this.indexLookup["2.96"] = 0.86;
        this.indexLookup["2.97"] = 0.86;
        this.indexLookup["2.98"] = 0.87;
        this.indexLookup["2.99"] = 0.87;
        this.indexLookup["3.00"] = 0.87;
        this.indexLookup["3.01"] = 0.88;
        this.indexLookup["3.02"] = 0.88;
        this.indexLookup["3.03"] = 0.88;
        this.indexLookup["3.04"] = 0.89;
        this.indexLookup["3.05"] = 0.89;
        this.indexLookup["3.06"] = 0.89;
        this.indexLookup["3.07"] = 0.9;
        this.indexLookup["3.08"] = 0.9;
        this.indexLookup["3.09"] = 0.9;
        this.indexLookup["3.10"] = 0.9;
        this.indexLookup["3.11"] = 0.91;
        this.indexLookup["3.12"] = 0.91;
        this.indexLookup["3.13"] = 0.91;
        this.indexLookup["3.14"] = 0.92;
        this.indexLookup["3.15"] = 0.92;
        this.indexLookup["3.16"] = 0.92;
        this.indexLookup["3.17"] = 0.92;
        this.indexLookup["3.18"] = 0.93;
        this.indexLookup["3.19"] = 0.93;
        this.indexLookup["3.20"] = 0.93;
        this.indexLookup["3.21"] = 0.93;
        this.indexLookup["3.22"] = 0.93;
        this.indexLookup["3.23"] = 0.94;
        this.indexLookup["3.24"] = 0.94;
        this.indexLookup["3.25"] = 0.94;
        this.indexLookup["3.26"] = 0.94;
        this.indexLookup["3.27"] = 0.94;
        this.indexLookup["3.28"] = 0.95;
        this.indexLookup["3.29"] = 0.95;
        this.indexLookup["3.30"] = 0.95;
        this.indexLookup["3.31"] = 0.95;
        this.indexLookup["3.32"] = 0.95;
        this.indexLookup["3.33"] = 0.96;
        this.indexLookup["3.34"] = 0.96;
        this.indexLookup["3.35"] = 0.96;
        this.indexLookup["3.36"] = 0.96;
        this.indexLookup["3.37"] = 0.96;
        this.indexLookup["3.38"] = 0.96;
        this.indexLookup["3.39"] = 0.96;
        this.indexLookup["3.40"] = 0.97;
        this.indexLookup["3.41"] = 0.97;
        this.indexLookup["3.42"] = 0.97;
        this.indexLookup["3.43"] = 0.97;
        this.indexLookup["3.44"] = 0.97;
        this.indexLookup["3.45"] = 0.97;
        this.indexLookup["3.46"] = 0.97;
        this.indexLookup["3.47"] = 0.97;
        this.indexLookup["3.48"] = 0.97;
        this.indexLookup["3.49"] = 0.98;
        this.indexLookup["3.50"] = 0.98;
        this.indexLookup["3.51"] = 0.98;
        this.indexLookup["3.52"] = 0.98;
        this.indexLookup["3.53"] = 0.98;
        this.indexLookup["3.54"] = 0.98;
        this.indexLookup["3.55"] = 0.98;
        this.indexLookup["3.56"] = 0.98;
        this.indexLookup["3.57"] = 0.98;
        this.indexLookup["3.58"] = 0.98;
        this.indexLookup["3.59"] = 0.98;
        this.indexLookup["3.60"] = 0.98;
        this.indexLookup["3.61"] = 0.98;
        this.indexLookup["3.62"] = 0.99;
        this.indexLookup["3.63"] = 0.99;
        this.indexLookup["3.64"] = 0.99;
        this.indexLookup["3.65"] = 0.99;
        this.indexLookup["3.66"] = 0.99;
        this.indexLookup["3.67"] = 0.99;
        this.indexLookup["3.68"] = 0.99;
        this.indexLookup["3.69"] = 0.99;
        this.indexLookup["3.70"] = 0.99;
        this.indexLookup["3.71"] = 0.99;
        this.indexLookup["3.72"] = 0.99;
        this.indexLookup["3.73"] = 0.99;
        this.indexLookup["3.74"] = 0.99;
        this.indexLookup["3.75"] = 0.99;
        this.indexLookup["3.76"] = 0.99;
        this.indexLookup["3.77"] = 0.99;
        this.indexLookup["3.78"] = 0.99;
        this.indexLookup["3.79"] = 0.99;
        this.indexLookup["3.80"] = 0.99;
        this.indexLookup["3.81"] = 0.99;
        this.indexLookup["3.82"] = 0.99;
        this.indexLookup["3.83"] = 0.99;
        this.indexLookup["3.84"] = 0.99;
        this.indexLookup["3.85"] = 0.99;
        this.indexLookup["3.86"] = 0.99;
        this.indexLookup["3.87"] = 0.99;
        this.indexLookup["3.88"] = 0.99;
        this.indexLookup["3.89"] = 0.99;
        this.indexLookup["3.90"] = 0.99;
        this.indexLookup["3.91"] = 0.99;
        this.indexLookup["3.92"] = 0.99;
        this.indexLookup["3.93"] = 0.99;
        this.indexLookup["3.94"] = 0.99;
        this.indexLookup["3.95"] = 0.99;
        this.indexLookup["3.96"] = 0.99;
        this.indexLookup["3.97"] = 0.99;
        this.indexLookup["3.98"] = 0.99;
        this.indexLookup["3.99"] = 0.99;
        this.indexLookup["4.00"] = 0.99;
        this.indexLookup["4.01"] = 0.99;
        this.indexLookup["4.02"] = 0.99;
        this.indexLookup["4.03"] = 0.99;
        this.indexLookup["4.04"] = 0.99;
        this.indexLookup["4.05"] = 0.99;
        this.indexLookup["4.06"] = 0.99;
        this.indexLookup["4.07"] = 0.99;
        this.indexLookup["4.08"] = 0.99;
        this.indexLookup["4.09"] = 0.99;
        this.indexLookup["4.10"] = 0.99;
        this.indexLookup["4.11"] = 0.99;
        this.indexLookup["4.12"] = 0.99;
        this.indexLookup["4.13"] = 0.99;
        this.indexLookup["4.14"] = 0.99;
        this.indexLookup["4.15"] = 0.99;
        this.indexLookup["4.16"] = 0.99;
        this.indexLookup["4.17"] = 0.99;
        this.indexLookup["4.18"] = 0.99;
        this.indexLookup["4.19"] = 0.99;
        this.indexLookup["4.20"] = 0.99;
        this.indexLookup["4.21"] = 0.99;
        this.indexLookup["4.22"] = 0.99;
        this.indexLookup["4.23"] = 0.99;
        this.indexLookup["4.24"] = 0.99;
        this.indexLookup["4.25"] = 0.99;
        this.indexLookup["4.26"] = 0.99;
        this.indexLookup["4.27"] = 0.99;
        this.indexLookup["4.28"] = 0.99;
        this.indexLookup["4.29"] = 0.99;
        this.indexLookup["4.30"] = 0.99;
        this.indexLookup["4.31"] = 0.99;
        this.indexLookup["4.32"] = 0.99;
        this.indexLookup["4.33"] = 0.99;
        this.indexLookup["4.34"] = 0.99;
        this.indexLookup["4.35"] = 0.99;
        this.indexLookup["4.36"] = 0.99;
        this.indexLookup["4.37"] = 0.99;
        this.indexLookup["4.38"] = 0.99;
        this.indexLookup["4.39"] = 0.99;
        this.indexLookup["4.40"] = 0.99;
        this.indexLookup["4.41"] = 0.99;
    }

    /////////////////////////////////////////////////////////
    // Index Lookup Generation END
    /////////////////////////////////////////////////////////

    /**
     * Given a value from FBM, get its 'bucket' value representation.
     * @private
     * @param {number} value 
     * @returns {string}
     */
    getBucket(value) {
        return value.toFixed(2);
    }

    /**
     * @param {number} x
     * @param {number} y
     * @param {number} limit 
     * @returns {number}
     */
    getIndexFromFbm(x, y, limit) {
        if (limit === 1) {
            return 0;
        }

        const value = this.indexFbm.calculateNoise(x, y) + this.shiftValue;
        if (value <= 0) {
            return 0;
        }

        const bucket = this.getBucket(value);

        let indexValue = this.indexLookup[bucket]; // [0-1]
        if (!indexValue) {
            return 0;
        }

        return (limit * indexValue) | 0;
    }

}